import React from "react";
import { TablePagination } from "components/pagination";
import { Format, ListBuilder, Table } from "@redriver/cinnamon";
import { getClientArchivedSignatories } from "features/Companies/Customers/Signatories/actions";
import CustomerSignatoryActions from "features/Companies/Customers/Signatories/CustomerSignatoryActions";

const ArchivedCustomerSignatoryTable = ({ clientId, onAdded, forceUpdate }) => {
  return (
    <ListBuilder
      withTable
      initialPagination={{ pageSize: 25, pageNumber: 1 }}
      dataTransform={(data) => data.results}
      totalTransform={(data) => data.totalResults}
      loadAction={getClientArchivedSignatories}
      loadParams={{ clientId, onAdded }}
      renderList={(tableProps, state, events) => (
        <div className="content-container principal-list">
          <Table
            {...tableProps}
            dataKey="id"
            emptyMessage="No Archived Signatories Found"
            selectable
            className="center-align"
          >
            <Table.Column field="name" title="Full Name" width="20%" />
            <Table.Column field="position" title="Position" width="10%" />
            <Table.Column
              title="Telephone"
              render={(item) =>
                `+${item.phoneCountryCode} (0) ${item.phoneNumber}`
              }
              width="20%"
            />
            <Table.Column field="email" title="Email" width="25%" />
            <Table.Column
              title="Date Archived"
              render={(item) => <Format.DateTime value={item.dateArchived} />}
              width="20%"
            />
            <Table.Column
              width="10%"
              render={(item) => (
                <CustomerSignatoryActions
                  state={item.state}
                  isArchived={item.isArchived}
                  signatoryId={item.id}
                  clientId={clientId}
                  forceUpdate={forceUpdate}
                />
              )}
            />
          </Table>
          <TablePagination
            pageNumber={state.pagination.pageNumber}
            onChange={events.onChangePagination}
            pageSize={state.pagination.pageSize}
            totalItems={state.total}
          />
        </div>
      )}
    />
  );
};
export default ArchivedCustomerSignatoryTable;
